<fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="point-transfer-success-page">
  <div class="card">
    <div class="card-heading">
      <h6 class="points-transfer-title text-success">
        {{ 'point.transfer.success.title' | translate }}
      </h6>
    </div>
    <div class="content">
      <div class="points-transfer-messages">
        {{ 'point.transfer.success.message' | translate }}
      </div>
      <div class="points-transfer-info">
        <div class="partner-details">
          <label>{{ 'point.transfer.person.detail' | translate }}</label>
          <span> {{ partner?.FullName }} ({{ partner?.Email }}) </span>
        </div>
        <div class="points-value">
          <label>{{ 'point.transfer.point.value' | translate }}</label>
          <span> {{ amount }} </span>
        </div>
      </div>
      <div class="wrap-btn">
        <button class="btn btn-back-to-points-transfer" (click)="backToPointsTransfer()">
          {{ 'back.to.points.transfer' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
